import React from "react";
import { Button } from "primereact/button";

interface StickyNewsButtonProps {
  onClick: () => void;
  hasUnread?: boolean;
  isModalVisible?: boolean; 
}

const StickyNewsButton: React.FC<StickyNewsButtonProps> = ({
  onClick,
  hasUnread = false,
  isModalVisible = false,
}) => {
  if (isModalVisible) {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        left: "15px",
        top: "120px",
        zIndex: 999,
      }}
    >
      <Button
        icon="pi pi-book"
        className="p-button-rounded p-button-lg"
        style={{
          background: "linear-gradient(to bottom, #4ade80, #15803d)",
          border: "none",
          padding: "12px",
          width: "56px",
          height: "56px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          transition: "all 0.2s ease",
        }}
        onClick={onClick}
        tooltip="View News"
        tooltipOptions={{ position: "bottom" }}
        aria-label="View News"
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "scale(1.1)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "scale(1)";
        }}
      >
        {hasUnread && (
          <span
            style={{
              position: "absolute",
              top: "4px",
              right: "10px",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "2px 8px",
              borderRadius: "9999px",
              fontSize: "8px",
              fontWeight: "500",
              backgroundColor: "#ef4444",
              color: "white",
            }}
          >
            News
          </span>
        )}
      </Button>
    </div>
  );
};

export default StickyNewsButton;
